import { memo } from 'react'

import { StatusBadge } from '@mangovoice/mango-ui'

import { useHotelsI18n } from '../../i18n'
import type { WakeupDisplayStatus } from '../../types/wakeup'
import { getWakeupDisplayConfig } from '../../utils/statusHelpers'

interface WakeupStatusBadgeProps {
  displayStatus: WakeupDisplayStatus
}

export const WakeupStatusBadge = memo(function WakeupStatusBadge({
  displayStatus,
}: WakeupStatusBadgeProps) {
  const { text } = useHotelsI18n()
  const displayConfig = getWakeupDisplayConfig(displayStatus)
  const label = text(
    `hotels.wakeupStatus.${displayStatus}`,
    displayConfig.label,
  )

  return (
    <StatusBadge
      status={displayStatus}
      config={{
        [displayStatus]: {
          label,
          colorPalette: displayConfig.colorPalette,
        },
      }}
    />
  )
})
